import { PromptTemplate } from '../types';

export const researchPrompt: PromptTemplate = {
  type: 'research',
  template: `First, provide a helpful conversational response that:
1. Acknowledges the user's research need naturally
2. Explains why this research would be valuable and how it connects to their goals
3. Provides context about research methodology, potential insights, or strategic benefits

Then, if you believe the user wants a research recommendation, include this structured format below your conversational response:

---RECOMMENDATION---
RESEARCH TITLE: [clear, descriptive research topic]
RESEARCH DESCRIPTION: [detailed description of research scope, objectives, and expected outcomes]
---END RECOMMENDATION---

Provide both the conversational response AND the structured recommendation in a single response. The conversational part maintains natural dialogue flow while the structured part enables action card creation.

OR if you need extra context to provide the perfect recommendation, continue chatting conversationally without the structured format.`,
  validation: {
    requiredFields: ['RESEARCH TITLE', 'RESEARCH DESCRIPTION'],
    stopKeywords: ['---RECOMMENDATION---', '---END RECOMMENDATION---'],
    maxRecommendations: 1
  }
}; 